__turbopack_context__.v({
  "companyWrapper": "Footer-module-scss-module__Dn7Lrq__companyWrapper",
  "container": "Footer-module-scss-module__Dn7Lrq__container",
  "containerEng": "Footer-module-scss-module__Dn7Lrq__containerEng",
  "content": "Footer-module-scss-module__Dn7Lrq__content",
  "contentEng": "Footer-module-scss-module__Dn7Lrq__contentEng",
  "contentWrapper": "Footer-module-scss-module__Dn7Lrq__contentWrapper",
  "contentWrapperEng": "Footer-module-scss-module__Dn7Lrq__contentWrapperEng",
  "footer": "Footer-module-scss-module__Dn7Lrq__footer",
  "iSol": "Footer-module-scss-module__Dn7Lrq__iSol",
  "mail": "Footer-module-scss-module__Dn7Lrq__mail",
  "ooo": "Footer-module-scss-module__Dn7Lrq__ooo",
  "phone": "Footer-module-scss-module__Dn7Lrq__phone",
  "popup": "Footer-module-scss-module__Dn7Lrq__popup",
  "popupButton": "Footer-module-scss-module__Dn7Lrq__popupButton",
  "popupText": "Footer-module-scss-module__Dn7Lrq__popupText",
});
